export default "__VITE_ASSET__Dt2zIva4__"